<template>
  <div class="carousel">
    <div class="block">
      <el-carousel trigger="click" height="498px">
        <el-carousel-item v-for="(item,index) in data" :key="index">
          <el-image style="width: 100%; height: 100%;" :src="$http+item.file" fit="fill"></el-image>
          <div class="carousel-text">
            <el-row>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-html="item.content">
                {{content}}
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <div class="more-about">
                  <el-button type="primary" @click="toContarct(item.naveto.url)">{{item.naveto.name}}</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>


  </div>
</template>

<script>
  export default {
    data() {
      return {
        content: '',
        name: '',
        url: '',
        data: []
      }
    },
    beforeCreate() {
      this.axios.get(this.$http + "api/index/getCarousel", {
          params: {}
        })
        .then((res) => {
          this.data = res.data.data;
        })
        .catch((err) => {})
    },
    mounted() {

    },
    methods: {
      toContarct: function(data) {
        this.$router.push({
          path: '/' + data,
        })
      }
    }
  }
</script>

<style scoped>
  .carousel h2 {
    color: rgba(255, 255, 255, 1);
    font-size: 40px;
    margin-bottom: 10px;
  }

  .carousel h4 {
    color: rgba(255, 255, 255, 1);
    font-size: 16px !important;
    margin-bottom: 20px;
    font-weight: normal;
    line-height: 30px;
  }

  .carousel {
    color: rgba(255, 255, 255, 1) !important;
  }

  .carousel-text {
    position: absolute;
    z-index: 99;
    padding: 20px;
    top: 50%;
    transform: translateY(-50%);
    left: calc(2%);
    width: 96%;
    text-align: center;
  }

  .carousel .el-row .el-col .more-about button {
    border-radius: 0 !important;
    position: relative;
    background-color: transparent;
    color: rgba(255, 255, 255, 0.7);
    font-weight: bolder;
    padding-top: 18px;
    padding-bottom: 18px;
    margin-top: 30px;
  }

  .carousel .el-row .el-col .more-about>.el-button::before {
    content: "";
    display: block;
    height: 100%;
    width: 5px;
    position: absolute;
    background: #5cb6ff;
    top: 0;
    left: -1px;
    z-index: -1;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
  }

  .carousel .el-row .el-col .more-about>.el-button:hover {
    color: rgba(255, 255, 255, 1);
  }

  .carousel .el-row .el-col .more-about>.el-button:hover::before {
    width: 100%;
    left: 0;
  }

  .el-image::after {
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
    width: 100%;
    height: 100%;
  }

  @media (max-width:600px) {
    .carousel-text {
      top: 0 !important
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Carousel.vue